import React from 'react';
const stats = [{
  value: '500+',
  label: 'Coaches',
  color: 'text-[#d4af37]'
}, {
  value: '1+5',
  label: 'Volume & Bonuses',
  color: 'text-[#d4af37]'
}, {
  value: '4.9/5',
  label: 'Rating ⭐',
  color: 'text-[#d4af37]'
}, {
  value: '🌍',
  label: 'Worldwide',
  color: 'text-white'
}];
const testimonials = [{
  quote: 'I planned my entire season in one evening. Every session now has a clear objective and I walk to the ground with full confidence.',
  name: 'James M.',
  role: 'Lancashire, UK'
}, {
  quote: 'My young players are developing so much faster. The progressions are logical and the kids can feel themselves improving.',
  name: 'Coach David',
  role: 'Melbourne, Australia'
}, {
  quote: 'I no longer spend hours searching for drills online. I open Cricket Ready and everything I need is right there.',
  name: 'Priya T.',
  role: 'Auckland, NZ'
}];
export function SocialProofBar() {
  return <section className="w-full bg-[#0A0A0A] py-12 px-4 border-b border-[#16161F]" data-id="element-186">
      <div className="max-w-5xl mx-auto" data-id="element-187">
        <div className="flex flex-wrap items-center justify-around gap-6 bg-[#16161F] border border-[#d4af37]/20 rounded-2xl px-6 py-6 mb-10 shadow-sm" data-id="element-188">
          {stats.map((s, i) => <div key={i} className="text-center min-w-[100px]" data-id="element-189">
              <div className={`text-3xl sm:text-4xl font-black ${s.color} tracking-tight`} data-id="element-190">
                {s.value}
              </div>
              <div className="text-[#B0B0C0] text-xs sm:text-sm font-bold mt-1 uppercase tracking-wider" data-id="element-191">
                {s.label}
              </div>
            </div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-192">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm flex flex-col" data-id="element-193">
              <div className="text-[#d4af37] text-lg mb-3" data-id="element-194">⭐⭐⭐⭐⭐</div>
              <p className="text-[#0A0A0A] text-sm sm:text-base font-medium italic flex-1 mb-4 leading-relaxed" data-id="element-195">
                "{t.quote}"
              </p>
              <div data-id="element-196">
                <div className="font-black text-[#0A0A0A] text-sm" data-id="element-197">
                  {t.name}
                </div>
                <div className="text-[#5A5A66] text-xs font-semibold" data-id="element-198">
                  {t.role}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}